export const validEmail = (value) => {
  const pattern = new RegExp(/(.+)@(.+){2,}\.(.+){2,}/);
  if (pattern.test(value)) {
    return true;
  }
  return false;
};

export const validNumber = (value) => {
  const pattern = new RegExp(/^[0-9]+($|€)/);
  if (pattern.test(value)) {
    return true;
  }
  return false;
};

export const validInput = (value) => {
  if (value !== "") {
    return true;
  }
  return false;
};
